import { render, staticRenderFns } from "./AboutOrganizationPage.vue?vue&type=template&id=1a45027d&scoped=true"
import script from "./AboutOrganizationPage.vue?vue&type=script&lang=js"
export * from "./AboutOrganizationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45027d",
  null
  
)

export default component.exports